'use client';
import useProduct from '@/contexts/ProductProvider';
import { MdTrendingUp } from 'react-icons/md';

const RecentlyViews = () => {
	const { globalData } = useProduct();

	return (
		<div className='d-flex items-center gap-10'>
			<MdTrendingUp size={30} className='text-portage' />
			<span className='fw-400 text-grey600'>{globalData?.ProductCountViewed || 0} People recently viewed this</span>
		</div>
	);
};

export default RecentlyViews;
